import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import useScrollDetection from "../../hooks/useScrollDetection";
import HOC from "../../components/HOC";
import SwipeDetailConsultation from "../../components/swipeComp/SwipeDetailConsultation";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getListConsultationHistory } from "../../services/telemedicineApi";

const ConsultationHistory = () => {
  const navigate = useNavigate();
  const isScrolled = useScrollDetection(5);

  const [showDetail, setShowDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);

  const { data, isFetching } = useQuery({
    queryKey: ["customer-consultation-history"],
    queryFn: () => getListConsultationHistory(""),
  });

  const STATUS_MAP = {
    0: { label: "Draft", color: "bg-gray-100 text-gray-600" },
    1: {
      label: "Menunggu Pembayaran",
      color: "bg-yellow-100 text-yellow-700",
    },
    2: { label: "Telah Dibayar", color: "bg-blue-100 text-blue-700" },
    3: { label: "Sedang Menunggu", color: "bg-indigo-100 text-indigo-700" },
    4: { label: "Dalam Sesi Chat", color: "bg-teal-100 text-teal-700" },
    5: {
      label: "Sesi Selesai",
      color: "bg-green-100 text-green-700",
    },
    6: { label: "Dibatalkan", color: "bg-red-100 text-red-700" },
  };

  return (
    <div className="bg-white relative">
      <div className="flex flex-row justify-center h-screen">
        <div className="w-full lg:w-1/2 flex justify-center lg:items-center px-0 lg:px-12 text-base">
          <div className="rounded-md py-4 px-3 lg:p-8 w-full h-fit">
            <div className="w-full">
              <div className="flex flex-col gap-2">
                {isFetching ? (
                  [1, 2, 3, 4].map((i) => (
                    <div
                      key={i}
                      className="flex flex-col w-full border border-slate-200 rounded-2xl p-3 space-y-3 animate-pulse"
                    >
                      <div className="flex w-full items-center gap-2">
                        <div className="w-10 h-10 rounded-full bg-slate-200 shrink-0" />
                        <div className="flex-1 space-y-1.5">
                          <div className="h-4 bg-slate-200 rounded w-2/3" />
                          <div className="flex items-center gap-2">
                            <div className="h-3 bg-slate-200 rounded w-24" />
                            <div className="h-5 bg-slate-200 rounded-full w-20" />
                          </div>
                        </div>
                      </div>

                      <hr />

                      <div className="flex gap-1">
                        <div className="h-4 bg-slate-200 rounded w-16" />
                        <div className="h-4 bg-slate-200 rounded w-32" />
                      </div>

                      <div className="flex items-center gap-2">
                        <div className="h-10 bg-slate-200 rounded-lg flex-1" />
                        <div className="h-10 bg-slate-200 rounded-lg flex-1" />
                      </div>
                    </div>
                  ))
                ) : data && data.length > 0 ? (
                  data.map((item, index) => (
                    <div
                      key={index}
                      className="flex flex-col w-full border border-slate-200 rounded-2xl p-3 space-y-3"
                    >
                      <div className="flex w-full items-center gap-2 font-medium">
                        <div className="w-10 h-10 object-cover rounded-full overflow-hidden shrink-0">
                          <img
                            src={item.doctor_image}
                            alt="Foto"
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="w-full">
                          <h1 className="text-slate-700 text-base font-semibold line-clamp-1 leading-tight">
                            {item.doctor_name}
                          </h1>
                          <div className="w-full flex items-center gap-2 text-sm mt-1">
                            <p className="text-slate-500">
                              {item.consultation_date}
                            </p>
                            <div
                              className={`text-sm px-2 py-0.5 rounded-full ${
                                STATUS_MAP[item.status]?.color ??
                                "bg-gray-100 text-gray-600"
                              }`}
                            >
                              <p className="font-medium">
                                {STATUS_MAP[item.status]?.label ?? item.status}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr className="my-1" />

                      <div className="font-medium text-md">
                        <p className="text-slate-700">
                          Diagnosa:{" "}
                          <span className="text-slate-500">
                            {item.diagnosis === "" ? "-" : item.diagnosis}
                          </span>
                        </p>
                      </div>

                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => {
                            setDataDetail(item);
                            setShowDetail(true);
                          }}
                          className="h-[40px] text-base border border-secondary flex items-center justify-center bg-white text-secondary w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline hover:bg-secondaryActive transform duration-200 hover:scale-100 disabled:bg-slate-300 disabled:border-slate-300 disabled:cursor-default"
                        >
                          Lihat Resep
                        </button>
                        <button
                          disabled={item.topic_id === ""}
                          onClick={() =>
                            navigate(
                              `/consultation/chat-with-doctor/${item.topic_id}`,
                              {
                                state: {
                                  type: 2,
                                },
                              },
                            )
                          }
                          className="h-[40px] text-base border border-secondary flex items-center justify-center bg-secondary text-white w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline hover:bg-secondaryHover transform duration-200 hover:scale-100 disabled:bg-slate-300 disabled:border-slate-300 disabled:cursor-default"
                        >
                          Lihat Chat
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-16 text-slate-400">
                    <p className="text-lg font-medium">
                      Belum ada riwayat konsultasi
                    </p>
                    <p className="text-sm mt-1">
                      Mulai konsultasi dengan dokter sekarang
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <SwipeDetailConsultation
        open={showDetail}
        setOpen={setShowDetail}
        data={dataDetail}
      />
    </div>
  );
};

export default HOC(ConsultationHistory, "required-auth");
